// extracted by mini-css-extract-plugin
export default {"withSidebar":"page_layout-module___withSidebar___c4825178","withLeftSidebar":"page_layout-module___withLeftSidebar___af1c1b46"};